import React, { useState } from "react";
import {
  Box,
  CssBaseline,
  Toolbar,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Outlet } from "react-router-dom";
import GuestHeader from "./GuestHeader";
import GuestSidebar from "./GuestSidebar";

const GuestLayout: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [drawerOpen, setDrawerOpen] = useState(!isMobile);

  const toggleDrawer = () => setDrawerOpen((prev) => !prev);
  const handleClose = () => setDrawerOpen(false);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <GuestHeader toggleDrawer={toggleDrawer} />
      <GuestSidebar
        open={drawerOpen}
        handleClose={handleClose}
        toggleDrawer={toggleDrawer}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerOpen ? 240 : 72}px)` },
          transition: "width 0.3s ease",
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
};

export default GuestLayout;
